import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import ConnectorListField from "./ConnectorListField";
import DataBindingListField from "./DataBindingListField";

const AutomationsTab = ({ node, onChange }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.PROCESS);
  const AUTO = t("CANVAS_EDITOR.STEP.AUTOMATIONS", { returnObjects: true });
  const CONNECTORS = t("FORM.STATUSES.CONNECTORS", { returnObjects: true });
  const DATA = t("FORM.STATUSES.DATA", { returnObjects: true });
  const data = node.data || {};

  const sections = [
    {
      key: "entryConnectors",
      title: AUTO.ENTRY,
      listLabels: { ...AUTO.ROWS, ADD: AUTO.ADD_ENTRY },
    },
    {
      key: "outputConnectors",
      title: AUTO.OUTPUT,
      listLabels: { ...AUTO.ROWS, ADD: AUTO.ADD_OUTPUT },
    },
  ];

  return (
    <div className="canvas-tab">
      <p className="canvas-tab__hint">{AUTO.INTRO}</p>
      {sections.map((section) => (
        <section
          key={section.key}
          className="canvas-tab__section canvas-tab__section--tight"
        >
          <h4 className="canvas-tab__subtitle">{section.title}</h4>
          <ConnectorListField
            value={data[section.key] || []}
            onChange={(next) => onChange(section.key, next)}
            labels={CONNECTORS}
            failureLabels={AUTO.FAILURE}
            listLabels={section.listLabels}
          />
        </section>
      ))}
      <section className="canvas-tab__section canvas-tab__section--tight">
        <h4 className="canvas-tab__subtitle">{AUTO.DATA}</h4>
        <DataBindingListField
          value={data.dataBindings || []}
          onChange={(next) => onChange("dataBindings", next)}
          labels={DATA}
          listLabels={{
            ...AUTO.ROWS,
            ADD: AUTO.ADD_DATA,
            EMPTY: AUTO.NO_DATA,
          }}
        />
      </section>
    </div>
  );
};

AutomationsTab.propTypes = {
  node: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default AutomationsTab;
